import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { CommonModule } from '@angular/common';
import { ToastrModule, ToastrService } from 'ngx-toastr';
import { ErrorhandlingService } from '../../Services/error-handling.service';
import { UnsubapiService } from '../../Services/unsubapi.service';

@Component({
  selector: 'app-unsubmail',
  standalone: true,
  imports: [CommonModule, ToastrModule],
  templateUrl: './unsubmail.component.html',
  styleUrl: './unsubmail.component.scss'
})
export class UnsubmailComponent implements OnInit {
  loading: boolean = true;
  status: 'success' | 'error' | 'already' = 'success';
  message: string = '';
  trackingId!: string;

  constructor(
    private route: ActivatedRoute,
    private apicalling: UnsubapiService,
    private toastr: ToastrService,
    private errorHandling: ErrorhandlingService
  ) {}

  ngOnInit(): void {
    // Query parameter 'trackingId' receive karna
    this.trackingId = this.route.snapshot.queryParams['trackingId'];

    if (this.trackingId) {
      this.unsubscribeEmail(this.trackingId);
    } else {
      this.loading = false;
      this.status = 'error';
      this.message = 'Invalid or missing tracking link.';
      this.toastr.error(this.message);
    }
  }

  private unsubscribeEmail(trackingId: string): void {
    this.apicalling
      .PostCallWithoutToken(null, `campaign/unsubscribe?trackingId=${trackingId}`)
      .subscribe({
        next: (response: any) => {
          this.loading = false;
          
          if (response.responseCode === 200) {
            this.status = 'success';
            this.message = response.responseMessage || 'You have successfully unsubscribed.';
            this.toastr.success(this.message);
          } else if (response.responseCode === 400) {
            // Agar pehle se unsubscribed ho ya bad request ho
            this.status = 'already';
            this.message = response.errorMessage || 'You are already unsubscribed.';
            this.toastr.info(this.message);
          } else {
            this.status = 'error';
            this.errorHandling.handleResponseError(response);
          }
        },
        error: (error: any) => {
          this.loading = false;
          this.status = 'error';
          this.errorHandling.handleHttpError(error);
        }
      });
  }

  // Action button jab user page close/exit karna chahta ho
  onClose(): void {
    window.close();
  }
}